module.exports = __webpack_public_path__ + "img/05.3491ca93.webp";